import { getTankDocRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreTankRepository extends BaseFirestoreRepository {
  async upsertEntity(entity, scope) {
    return this.upsert(
      getTankDocRef(this.db, entity.id),
      this.addStorageMarker({
        ...entity,
        organizationId: scope.organizationId,
      })
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getTankDocRef(this.db, entityId));
  }
}
